/**
 * Visual horizontal divider. Optional title (labelPl) renders inline; placeholder
 * "—" jest traktowany jak brak tytułu (admin wstawił SEPARATOR bez podpisu).
 */
export function SeparatorRow({ labelPl }: { labelPl: string }) {
  const hasTitle = labelPl && labelPl !== '—'
  return (
    <div className="py-3">
      {hasTitle ? (
        <div className="flex items-center gap-3">
          <span className="text-xs uppercase tracking-wide text-slate-500 whitespace-nowrap">{labelPl}</span>
          <hr className="flex-1 border-slate-200" />
        </div>
      ) : (
        <hr className="border-slate-200" />
      )}
    </div>
  )
}
